export enum StatsigGates {
  USAGE_BILLED_BILLING = 'usage-billed-billing',
  SUBSCRIPTION_GATE = 'subscription-gate',
}
